import { format } from 'sql-formatter'

import { CodeHighlighter } from './CodeHighlighter'

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function SqlSyntaxHighlighter({
  sql,
  language,
  onClick,
}: {
  sql: string
  language?: 'postgresql' | 'sql'
  onClick?: () => void
}) {
  return (
    <div className={onClick === undefined ? `` : `cursor-pointer hover:opacity-90`} onClick={onClick}>
      <CodeHighlighter language="sql" customStyle={{ padding: 10 }} wrapLongLines={true}>
        {format(sql, {
          language: language ?? 'postgresql',
        })}
      </CodeHighlighter>
    </div>
  )
}
